<div class="dropdown d-inline-block">
  <a
    class="dropdown-toggle no-caret ps-2"
    id="applications"
    data-toggle="dropdown"
    aria-haspopup="true"
    aria-expanded="false"
    placement="bottom"
    ngbTooltip="Features"
  >
    <i class="fal fa-th"></i>
  </a>

  <div
    class="applications dropdown-menu dropdown-menu-right rounded-0 mt-3 box-shadow"
    aria-labelledby="applications"
  >
    <div class="dropdown-menu-content text-center" perfectScrollbar>
      <h5 class="py-3 mb-0">Features</h5>
      <hr class="mt-0" />
      <div class="row">
        <div class="col-4 p-1 mb-3 item">
          <a class="feature-link">
            <i class="fal fa-calendar" aria-hidden="true"></i>
            <span class="d-block">Order Window</span>
          </a>
        </div>
        <div class="col-4 p-1 mb-3 item transition">
          <a class="feature-link">
            <i class="fal fa-shopping-cart" aria-hidden="true"></i>
            <span class="d-block">eCommerce</span>
          </a>
        </div>
        <div class="col-4 p-1 mb-3 item transition">
          <a routerLink="/account/profile">
            <i class="fal fa-user" aria-hidden="true"></i>
            <span class="d-block">My Account</span>
          </a>
        </div>
      </div>
    </div>
    <div class="overlay-tab ot-grey">
      <i class="fal fa-th" aria-hidden="true"></i>
    </div>
  </div>
</div>
